<template>
  <div id="disclaimer" v-if="hasCookie !== true">
    <div class="disclaimer-container">
      <span class="text">This site uses cookies and external scripts to improve your experience.</span>
      <button class="button" @click="accept">ACCEPT</button>
    </div>
  </div>
</template>

<script>
const name = 'disclaimer'

const methods = {
  accept () {
    const wrap = document.querySelector('.application--wrap')
    wrap.style['padding-bottom'] = '0px'
    this.hasCookie = true
    document.cookie = 'op_forecasting_cookie_disclaimer=accept; expires=Fri, 31 Dec 9999 23:59:59 GMT'
  }
}

export default {
  name,
  methods,
  data () {
    /* eslint-disable-next-line */
    const cookieValue = document.cookie.replace(/(?:(?:^|.*;\s*)op_forecasting_cookie_disclaimer\s*\=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      hasCookie: cookieValue === 'accept'
    }
  },
  mounted () {
    if (this.hasCookie === false) {
      const wrap = document.querySelector('.application--wrap')
      const disc = document.querySelector('#disclaimer')
      wrap.style['padding-bottom'] = `${disc.offsetHeight}px`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Disclaimer.vue